import { TAction } from '../../../../../shared/frontend/scripts/actions/types/action';
import { IReplaysOptions, TReplayListFetchStatus, TReplaysManagementState } from '../libs/store';
import { TReplayParams, TReplaySetOptionsParams } from '../services/apiService';

const getInitialState = (): TReplaysManagementState => ({
  isLoading: false,
  isLoaded: false,
  replayList: {
    isLoaded: false,
    list: [],
    fetchStatus: 'idle'
  },
  replaysOptions: {
    isLoaded: false,
    options: null
  },
  error: null,
  selectedRegion: 'us',
  loadingKeystoneRunId: null
});

// Action Types
const ADD_REPLAY = 'REPLAYS_MANAGEMENT/ADD_REPLAY';
const REMOVE_REPLAY = 'REPLAYS_MANAGEMENT/REMOVE_REPLAY';
const GET_REPLAY_LIST = 'REPLAYS_MANAGEMENT/GET_REPLAY_LIST';
const GET_REPLAYS_OPTIONS = 'REPLAYS_MANAGEMENT/GET_REPLAYS_OPTIONS';
const SAVE_REPLAYS_OPTIONS = 'REPLAYS_MANAGEMENT/SAVE_REPLAYS_OPTIONS';
const SAVE_REPLAY_SET_OPTIONS = 'REPLAYS_MANAGEMENT/SAVE_REPLAY_SET_OPTIONS';

const SET_LOADING = 'REPLAYS_MANAGEMENT/SET_LOADING';
const SET_LOADING_KEYSTONE_RUN = 'REPLAYS_MANAGEMENT/SET_LOADING_KEYSTONE_RUN';
const SET_FAILURE = 'REPLAYS_MANAGEMENT/SET_FAILURE';
const SET_SELECTED_REGION = 'REPLAYS_MANAGEMENT/SET_SELECTED_REGION';

const LOAD_REPLAY_LIST = 'REPLAYS_MANAGEMENT/LOAD_REPLAY_LIST';
const LOAD_REPLAYS_OPTIONS = 'REPLAYS_MANAGEMENT/LOAD_REPLAYS_OPTIONS';
const SET_REPLAY_LIST_FETCH_STATUS = 'REPLAYS_MANAGEMENT/SET_REPLAY_LIST_FETCH_STATUS';

// Actions
const addReplay = (payload: TReplayParams) => {
  return {
    type: ADD_REPLAY,
    payload
  };
};

const removeReplay = (payload: TReplayParams) => {
  return {
    type: REMOVE_REPLAY,
    payload
  };
};

const getReplayList = (region?: string) => {
  return {
    type: GET_REPLAY_LIST,
    payload: region
  };
};

const getReplaysOptions = () => {
  return {
    type: GET_REPLAYS_OPTIONS
  };
};

const saveReplaysOptions = (payload: Partial<IReplaysOptions>) => {
  return {
    type: SAVE_REPLAYS_OPTIONS,
    payload
  }
}

const saveReplaySetOptions = (payload: TReplaySetOptionsParams) => {
  return {
    type: SAVE_REPLAY_SET_OPTIONS,
    payload
  }
}

const setLoading = (payload: Pick<TReplaysManagementState, 'isLoading'>) => {
  return {
    type: SET_LOADING,
    payload
  };
};

const setLoadingKeystoneRun = (payload: Pick<TReplaysManagementState, 'loadingKeystoneRunId'>) => {
  return {
    type: SET_LOADING_KEYSTONE_RUN,
    payload
  };
};

const setFailure = (payload: Pick<TReplaysManagementState, 'error'>) => {
  return {
    type: SET_FAILURE,
    payload
  };
};

const setSelectedRegion = (payload: Pick<TReplaysManagementState, 'selectedRegion'>) => {
  return {
    type: SET_SELECTED_REGION,
    payload
  };
};

const loadReplayList = (payload: Pick<TReplaysManagementState, 'replayList'>) => {
  return {
    type: LOAD_REPLAY_LIST,
    payload
  };
};

const loadReplaysOptions = (payload: Pick<TReplaysManagementState, 'replaysOptions'>) => {
  return {
    type: LOAD_REPLAYS_OPTIONS,
    payload
  };
};

const setReplayListFetchStatus = (fetchStatus: TReplayListFetchStatus) => {
  return {
    type: SET_REPLAY_LIST_FETCH_STATUS,
    payload: { fetchStatus }
  };
};

export function reducer(state: any = getInitialState(), action: TAction<any>): TReplaysManagementState {
  switch (action.type) {
    case SET_LOADING:
    case SET_LOADING_KEYSTONE_RUN:
    case LOAD_REPLAY_LIST:
    case LOAD_REPLAYS_OPTIONS:
    case SET_SELECTED_REGION:
    case SET_FAILURE: {
      return { ...state, ...action.payload };
    }
    case SET_REPLAY_LIST_FETCH_STATUS: {
      return {
        ...state,
        replayList: {
          ...state.replayList,
          fetchStatus: action.payload.fetchStatus
        }
      };
    }
    default:
      return state;
  }
}

export const actions = {
  addReplay,
  removeReplay,
  getReplayList,
  getReplaysOptions,
  saveReplaysOptions,
  saveReplaySetOptions,

  setLoading,
  setLoadingKeystoneRun,
  setFailure,
  setSelectedRegion,
  setReplayListFetchStatus,

  // load action
  loadReplayList,
  loadReplaysOptions
};

export const actionTypes = {
  ADD_REPLAY,
  REMOVE_REPLAY,
  GET_REPLAY_LIST,
  GET_REPLAYS_OPTIONS,
  SAVE_REPLAYS_OPTIONS,
  SAVE_REPLAY_SET_OPTIONS,

  SET_LOADING,
  SET_LOADING_KEYSTONE_RUN,
  SET_FAILURE,
  SET_REPLAY_LIST_FETCH_STATUS,

  SET_SELECTED_REGION,

  LOAD_REPLAY_LIST,
  LOAD_REPLAYS_OPTIONS
};
